import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RequestState {
  openPopoverIndex: number | null;
  searchTextInput: string;
  userShopRequestTypes: any;
  activities: any;
  storage_host_cluster_Id: any;
  errorStatus: {
    title: string;
    message: string;
  };
  warning: boolean;
  warning2: boolean;
  dobRequest: any;
}

const initialState: RequestState = {
  openPopoverIndex: null,
  searchTextInput: "",
  userShopRequestTypes: null,
  activities: null,
  storage_host_cluster_Id: null,
  errorStatus: { title: "", message: "" },
  warning: false,
  warning2: false,
  dobRequest: null,
};
const requestSlice = createSlice({
  name: "request",
  initialState,
  reducers: {
    setOpenPopoverIndex: (state, action) => {
      state.openPopoverIndex = action.payload;
    },
    setSearchTextInput: (state, action: PayloadAction<string>) => {
      state.searchTextInput = action.payload;
    },
    setUserShopRequestTypes: (state, action: PayloadAction<any>) => {
      state.userShopRequestTypes = action.payload;
    },
    setActivities: (state, action: PayloadAction<any>) => {
      state.activities = action.payload;
    },
    setStorageHostClusterId: (state, action: PayloadAction<any>) => {
      state.storage_host_cluster_Id = action.payload;
    },
    setErrorStatus: (state, action: PayloadAction<{ title: string; message: string }>) => {
      state.errorStatus = action.payload;
    },
    setWarning: (state, action: PayloadAction<boolean>) => {
      state.warning = action.payload;
    },
    setWarning2: (state, action: PayloadAction<boolean>) => {
      state.warning2 = action.payload;
    },
    setDobRequest: (state, action: PayloadAction<any>) => {
      state.dobRequest = action.payload;
    },
  },
});

export const { setOpenPopoverIndex, setSearchTextInput, setUserShopRequestTypes, setActivities, setStorageHostClusterId, setErrorStatus, setWarning, setWarning2, setDobRequest } =
  requestSlice.actions;

const requestReducer = requestSlice.reducer;
export default requestReducer;
